import { Avatar, Badge, Box, Paper } from '@mui/material';
import { orange } from '@mui/material/colors';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/authContext';
import { useTheme } from '../../contexts/themeContext';
import { NAME_SEPARATOR, User } from '../../firebase/api';
import capsatLogoDarkMode from '../../icons/capsat-logo-dark-mode.png';
import capsatLogoLightMode from '../../icons/capsat-logo-light-mode.png';

export function getInitials(user: User) {
  return user.names
    .map(name => name[0].toUpperCase())
    .slice(0, 2)
    .join(NAME_SEPARATOR.trim());
}

export interface HeaderProps {
  badgeCount: number;
}

export function Header({ badgeCount }: HeaderProps) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { darkModeEnabled } = useTheme();

  const handleAvatarClick = () => {
    navigate('profile', {
      state: { prevPathname: location.pathname },
    });
  };

  const handleNotSignedInAvatarClick = () => {
    navigate('login', {
      state: { prevPathname: location.pathname },
    });
  };

  return (
    <Box sx={{ position: 'sticky', top: 0, zIndex: 1000 }}>
      <Paper
        square
        elevation={0}
        sx={{
          display: 'flex',
          alignItems: 'center',
          p: 2,
          bgcolor: 'background.default',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            flexGrow: 1,
          }}
          onClick={() => navigate('/')}
        >
          <img
            src={darkModeEnabled ? capsatLogoDarkMode : capsatLogoLightMode}
            alt="logo"
            height="36px"
          />
        </Box>

        {user !== null ? (
          <Badge
            badgeContent={badgeCount}
            color="primary"
            sx={{ '& .MuiBadge-badge': { right: 3, top: 3 } }}
          >
            {user.profilePicture !== undefined ? (
              <Avatar src={user.profilePicture} onClick={handleAvatarClick} />
            ) : (
              <Avatar sx={{ bgcolor: orange[700] }} onClick={handleAvatarClick}>
                {getInitials(user)}
              </Avatar>
            )}
          </Badge>
        ) : (
          <Avatar onClick={handleNotSignedInAvatarClick} />
        )}
      </Paper>
    </Box>
  );
}
